import { render, staticRenderFns } from "./OrdersSalesModule.vue?vue&type=template&id=1d900bda"
import script from "./OrdersSalesModule.vue?vue&type=script&lang=js"
export * from "./OrdersSalesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports